import logo from './logo.svg';
import './App.css';
import Home from './components/home/Home';
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProductDetails from './components/product/ProductDetails';
import Shop from './components/shop/Shop';
import ContactUs from './components/contact/ContactUs';
import Cart from './components/cart/Cart';
import Checkout from './components/cart/Checkout';
import { ROUTES } from './constant/routes';
import 'react-phone-input-2/lib/style.css';
import Order from './components/order/Order';
import ProductByCategory from './components/category/ProductByCategory';
import Wishlist from './components/wishlist/Wishlist';
import Terms from './components/policies/Terms';
import PrivacyPolicy from './components/policies/PrivacyPolicy';
import AboutUs from './components/policies/AboutUs';
import RefundPolicy from './components/policies/RefundPolicy';
import Cancellation from './components/policies/Cancellation';
import Success from './components/payment-gateway/Success';
import "react-country-state-city/dist/react-country-state-city.css";
import Offers from './components/home/Offers';
import Offer from './components/offers/Offer';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { count_visitors } from './redux/actions/HomeAction';
import Search from './components/search/Search';
import CashfreeHD from './payment-gateway/cashfree-hd/CashfreeHD';
import PaymentCashfreeHD from './payment-gateway/PaymentCashfreeHD';
import CashfreeGold from './payment-gateway/cashfree-gold/CashfreeGold';
import CashfreeNattu from './payment-gateway/cashfree-nattu/CashfreeNattu';
import CashfreeAddaTV from './payment-gateway/cashfree-addatv/CashfreeAddaTV';
import CashfreeBoomax from './payment-gateway/cashfree-boomax/CashfreeBoomax';
import CashfreeMoodx from './payment-gateway/cashfree-moodx/CashfreeMoodx';
import CashfreeNavarsa from './payment-gateway/cashfree-navarsa/CashfreeNavarsa';
import CashfreeRatriflix from './payment-gateway/cashfree-ratriflix/CashfreeRatriflix';
import PayUBoomax from './pay-u/pay-u-boomax/PayUBoomax';
import PaymentSuccessPayU from './pay-u/PaymentSuccessPayU';
import PaymentFailedPayU from './pay-u/PaymentFailedPayU';
import PayUMoodx from './pay-u/pay-u-moodx/PayUMoodx';
import PayUNavarsa from './pay-u/pay-u-navarsa/PayUNavarsa';
import PayUHD from './pay-u/pay-u-hd/PayUHD';
import PayUAddaTv from './pay-u/pay-u-addatv/PayUAddaTv';
import PayUGold from './pay-u/pay-u-gold/PayUGold';
import PayUYessmapro from './pay-u/pay-u-yessmapro/PayUYessmapro';


function App() {
  const visited = sessionStorage.getItem("visited")
  const dispatch = useDispatch()

  useEffect(() => {
    if (!visited) {
      dispatch(count_visitors())
      sessionStorage.setItem("visited", true)
    }
  }, [])
  return (
    <>
      <RouteScrollToTop />
      <PhosphorIconInit />
      <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={`${ROUTES.productDetails}/:slug`} element={<ProductDetails />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/cart" element={<Cart />} />
        <Route path={ROUTES.checkout} element={<Checkout />} />
        <Route path={ROUTES.MyOrders} element={<Order />} />
        <Route path={ROUTES.ProductByCategory} element={<ProductByCategory />} />
        <Route path={ROUTES.wishlist} element={<Wishlist />} />
        <Route path={ROUTES.terms_conditioon} element={<Terms />} />
        <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicy />} />
        <Route path={ROUTES.aboutUs} element={<AboutUs />} />
        <Route path={ROUTES.refundPolicy} element={<RefundPolicy />} />
        <Route path={ROUTES.cancellationPolicy} element={<Cancellation />} />
        <Route path={ROUTES.paymentSuccess} element={<Success />} />
        <Route path={ROUTES.offers} element={<Offer />} />
        <Route path={ROUTES.search} element={<Search />} />


        {/* Payment gateway */}
        <Route path="/prmhd/:slug" element={<CashfreeHD />} />
        <Route path="/prmgold/:slug" element={<CashfreeGold />} />
        <Route path="/payntu/:slug" element={<CashfreeNattu />} />
        <Route path="/vtaq/:slug" element={<CashfreeAddaTV />} />
        <Route path="/payxam/:slug" element={<CashfreeBoomax />} />
        <Route path="/paynav/:slug" element={<CashfreeNavarsa />} />

        <Route path="/cfr-payment-success" element={<PaymentCashfreeHD />} />

        <Route path="/cashfree-paymdx/:slug" element={<CashfreeMoodx />} />
        <Route path="/cashfree-ratriflix/:slug" element={<CashfreeRatriflix />} />

        {/* Pay U payment gateway */}
        <Route path="/payuxmb/:slug" element={<PayUBoomax />} />
        <Route path="/payuxdm/:slug" element={<PayUMoodx />} />
        <Route path="/payunav/:slug" element={<PayUNavarsa />} />
        <Route path="/payuhd/:slug" element={<PayUHD />} />
        <Route path="/payuada/:slug" element={<PayUAddaTv />} />
        <Route path="/payugld/:slug" element={<PayUGold />} />
        <Route path="/payuysm/:slug" element={<PayUYessmapro />} />
        <Route path="/payment-success-payu/:slug" element={<PaymentSuccessPayU />} />
        <Route path="/payment-failed-payu/:slug" element={<PaymentFailedPayU />} />



      </Routes>
    </>
  );
}

export default App;
